import { MouseEvent } from "react";
import {
  Button,
  TabbedDrawer,
  TabbedDrawerHeader,
  TabbedDrawerTitle,
  TabbedDrawerTab,
  TabbedDrawerCTA,
} from "@sellar-io/components";
import { OpeningOrderFeeListResponseType } from "@sellar-io/api-v2/types";
import { OOfDrawerContent } from "./OofDrawerContent";
import dayjs from "dayjs";

enum OOFDrawerTabs {
  OOF,
}

export const OofDrawer = ({
  active,
  setActive,
  oof,
}: {
  active: boolean;
  setActive: (value: boolean) => void;
  oof?: OpeningOrderFeeListResponseType[number];
}) => {
  const invoiceLink = oof?.InvoiceLineItem?.Invoice?.stripeInvoiceUrl || null;
  const viewStripeInvoice = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!!invoiceLink) {
      window.open(invoiceLink, "_blank");
    }
  };

  return (
    <TabbedDrawer
      active={active}
      setActive={setActive}
      initTab={OOFDrawerTabs.OOF}
    >
      <TabbedDrawerHeader>
        <TabbedDrawerTitle
          title={`Order #${oof?.Order.id}`}
          subtitle={`Invoice ${dayjs(oof?.createdAt).format("DD/MM/YYYY")}`}
        />
      </TabbedDrawerHeader>
      <TabbedDrawerTab tab={OOFDrawerTabs.OOF}>
        {!!oof && (
          <OOfDrawerContent fee={oof} onDismiss={() => setActive(false)} />
        )}
      </TabbedDrawerTab>
      <TabbedDrawerCTA>
        <Button
          className="w-full"
          disabled={!invoiceLink}
          onClick={(e) => viewStripeInvoice(e)}
        >
          Download invoice
        </Button>
      </TabbedDrawerCTA>
    </TabbedDrawer>
  );
};
